
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const ZatapAdvertisement = () => (
  <div className="rounded-xl bg-gradient-to-br from-blue-100 via-blue-50 to-white p-6 flex flex-col shadow-lg items-center">
    <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-2 text-center">Kokeile kilpailutusta – saat tarjoukset usealta pankilta!</h3>
    <p className="text-blue-800 mb-4 text-center">Täytä hakemus alle 2 minuutissa, eikä se sido mihinkään.</p>
    <Link 
      to="/kilpailuta?loanType=renovation" 
      className="inline-flex items-center gap-2 bg-blue-500 text-white text-base font-bold rounded-lg px-6 py-3 hover:bg-blue-600 transition shadow"
    >
      Kilpailuta remonttilaina
      <ArrowRight className="h-5 w-5" />
    </Link>
  </div>
);
